import {ReactComponent as SearchIcon} from './icons/round-search.svg';
import {SearchModal} from '../SearchModal/SearchModal';
import React, {useState} from 'react';
import styled from 'styled-components';
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";

const SearchIconStyled = styled(SearchIcon)`
  fill: #b0b0b0;
`;

SearchIconStyled.displayName = 'SearchIconStyled';

interface SearchProps {
    toggleVerticalMenu?: () => void;
}

export const Search: React.FC<SearchProps> = ({ toggleVerticalMenu }) => {
    const [openSearchKeyboard, setOpenSearchKeyboard] = useState(false);
    const {t} = useTranslation();
    const [isMobile, setMobile] = useState(false);

    React.useEffect(() => {
        setMobile(window.innerWidth < 822);
    }, [window.innerWidth]);

    function openKeyboard() {
        if (!isMobile) {
            setOpenSearchKeyboard(true);
        }
    }

    const banner = <>
        <div className="h-[24px] w-[24px]">
            <SearchIconStyled/>
        </div>
        <span className="text-[#4B4B4B] text-[16px]">
                   {t('verticalMenuItems.Search')}
        </span>
    </>

    if (isMobile) {
        return <Link to="/sport/search"
                     className="cursor-pointer bg-white flex items-center gap-[21px] h-[40px] notebook:h-[48px] pl-[16px]"
                     onClick={toggleVerticalMenu}>{banner}</Link>;
    } else {
        return <>
            <div
                onClick={openKeyboard}
                className="cursor-pointer bg-white flex items-center gap-[21px] h-[40px] notebook:h-[48px] pl-[16px]"
            >
                {banner}
            </div>
            <SearchModal open={openSearchKeyboard} setOpen={setOpenSearchKeyboard}/>
        </>;
    }
};
